import { useWindowDimensionsContext } from './useWindowDimensionsContext';
import { useBreakpoint } from './useBreakpoint';

export function useDeviceSize() {
  const { deviceWidth } = useWindowDimensionsContext();
  return useBreakpoint(deviceWidth);
}
